export default __webpack_public_path__ + "static/universe-7e72ab1017343298af567b28eea37c49.svg";